import {getSearchCookie} from './cookies';
import {TESTS, getValue} from '../utils/abacus';
import {getNextWeekSaturday, getTwoMonthsOutLastSaturday, addDays} from './date';

/**
 * @param {Date|null} date
 * @returns {string|null} The date string in ISO format (YYYY-MM-DD)
 */
const getDateString = (date) => date && date.toISOString().split('T')[0];

const isBrowser = typeof window !== 'undefined';

const getDefaultDates = (refDate, abacus) => {
    let arrivalDate = null;
    let departureDate = null;

    if (isBrowser) { // We don't want to use the server time
        const defaultDatesVariant = getValue(abacus, TESTS.DEFAULT_SEARCHBOX_DATES);
        if (defaultDatesVariant === 1) {
            arrivalDate = getNextWeekSaturday(refDate);
        } else if (defaultDatesVariant === 2) {
            arrivalDate = getTwoMonthsOutLastSaturday(refDate);
            departureDate = addDays(arrivalDate, 7);
        }
    }

    return {arrivalDate, departureDate};
};

export function getDatesFromCookie(searchCookieValues, abacus) {
    const now = new Date();

    const {arrival, departure} = searchCookieValues;
    const arrivalMs = Date.parse(arrival);
    const departureMs = Date.parse(departure);

    const todayMs = Date.parse(getDateString(now));

    if (arrival && departure && arrivalMs >= todayMs && arrivalMs < departureMs) {
        return {
            arrivalDate: arrival,
            departureDate: departure
        };
    }

    const {arrivalDate, departureDate} = getDefaultDates(now, abacus);
    return {
        arrivalDate: getDateString(arrivalDate),
        departureDate: getDateString(departureDate)
    };
}

export function getTypeOfGuestFromCookie(cookieGuests, defaultNumber) {
    const guests = parseInt(cookieGuests, 10);

    if (isNaN(guests)) {
        return defaultNumber;
    }

    return guests;
}

export function getGuestsFromCookie(searchCookieValues) {
    const defaultChildren = 0;
    const defaultAdults = 0;
    const defaultPetIncluded = false;

    const {numberOfAdults, numberOfChildren, petIncluded} = searchCookieValues;

    const adults = getTypeOfGuestFromCookie(numberOfAdults, defaultAdults);

    if (adults === 0) {
        return {
            adults: defaultAdults,
            children: defaultChildren,
            petIncluded: defaultPetIncluded
        };
    }

    const children = getTypeOfGuestFromCookie(numberOfChildren, defaultChildren);

    return {
        adults,
        children,
        petIncluded: typeof petIncluded === 'string' ? petIncluded === 'true' : petIncluded
    };
}

export function getSearchValues(cookies, abacus) {
    const searchCookieValues = getSearchCookie(cookies);

    return {
        ...getDatesFromCookie(searchCookieValues, abacus),
        ...getGuestsFromCookie(searchCookieValues)
    };
}
